import { Collapse, CollapseItem, Upload, DatePicker, TimeSelect, Table, TableColumn, Tag, Input, Button, Select, Option, Popover, Tree, Col } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import { Switch as LSwitch } from '@/components/index';

import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
const svc = new ResourceSvc();
import RaceResult from '@/components/shared/race-result/race-result.vue';
import FilterBar from '@/components/admin/ranking/filter-bar/filter-bar.vue';

export default {
    name: 'UploadResults',
    props: ['selectedSerieIndex', 'selectedYearIndex'],
    components: {
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Table.name]: Table, [TableColumn.name]: TableColumn, [DatePicker.name]: DatePicker, [TimeSelect.name]: TimeSelect, [Tag.name]: Tag, [Input.name]: Input, [Select.name]: Select, [Option.name]: Option, [Upload.name]: Upload, [Button.name]: Button,
        [Popover.name]: Popover, LSwitch,
        'race-result': RaceResult,
        'filter-bar': FilterBar,
    },
    data() {
        return {
            isUploadFromOldRankings: false,

            isLoadClubsRankingFromOldRankingRequest: false,
            isLoadClubsRankingFromOldRankingSuccess: false,

            isLoadFromOldRankingRequest: false,
            isLoadFromOldRankingSuccess: false,

            isDeleteRacesResultsFromSerieRequest: false,
            isDeleteRacesResultsFromSerieSuccess: false,

            isDeleteRacesFromSerieRequest: false,
            isDeleteRacesFromSerieSuccess: false,

            yearCalculationsFrom: 0,
            organizations: [],
            distances: [],
            currentRaceId: null,
            isLoadingData: false,
            loadedResults: null,
            loadedResultsFile: null,
            isPreviewMode: false,
            isPreviewFirst: false,

            isCalculationsSuccess: false,
            isCalculationsResult: false,
            calculationsError: null,

            isUpdateResultsRequest: false,
            isUpdateResultsMode: false,

            isUpdateProcessed: false,
            isUpdateSuccess: false,
            updateError: null,
            oldDBError: null,

            isDeleteProcessed: false,
            isDeleteSuccess: false,
            deleteError: null,

            isLoadFromDataBaseRequest: false,
            isLoadFromDataBaseMode: false,
            isCheckResultsMatch: false,

            fileColumnLength: 21,
            fileColumnIndexes: [],
            isLoadFromFileRequest: false,
            isLoadFromFileMode: false,
            isFileLoaded: false,
            fileAcceptTypes: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileAcceptExtentions: '.csv, .xlsx',
            isProcessing: false,
            errorMessage: null,
            data: [],
            years: ["Initialization"],
            series: ["Initialization"],
            selectedYear: null,
            selectedYearLabel: null,
            selectedSerie: null,
            selectedSerieLabel: null,
            noRacesEntry: { name: "No races found", id: null, enumValue: 0 },
            races: [],
            racesInput: [],
            racesFiltered: [],

            perPage: 10,
        };
    },
    computed: {
        isPossibleCalulations() {
            return true; //this.selectedYear >= this.yearCalculationsFrom;
        },
        currentRaceName() {
            var race = this.races.filter(x => x.id == this.currentRaceId);
            return race && race.length ? race[0].name : null;
        },
        isPreviewModeActivated() {
            return (this.isFileLoaded || this.isUpdateResultsMode || this.isCheckResultsMatch) && this.loadedResults && this.isPreviewMode;
        },
        isVisibleWorkflow() {
            return this.years && this.years.length && this.series && this.series.length;
        },
        isNotVisibleWorkflow() {
            return (!this.years || !this.years.length || !this.series || !this.series.length) && !this.isProcessing;
        },
        from() {
            if (!this.races || !this.races.length || !this.races[0].id) {
                return 0;
            }
            var res = (this.page - 1) * this.perPage + 1;
            if (res >= this.racesFiltered.length) {
                if (this.racesFiltered.length - this.perPage > 0) {
                    res = this.racesFiltered.length - this.perPage;
                }
                else {
                    res = 0;
                    this.page = 1;
                }
            }
            return res;
        },
        to() {
            if (!this.races || !this.races.length || !this.races[0].id) {
                return 0;
            }
            return this.racesFiltered.length > (this.page - 1) * this.perPage + this.perPage ? (this.page - 1) * this.perPage + this.perPage : this.racesFiltered.length;
        },
        total() {
            if (!this.races || !this.races.length || !this.races[0].id) {
                return 0;
            }

            return this.racesFiltered.length;
        }
    },
    methods: {
        getPreviewColumnStyles() {
            var width = 100 / this.loadedResults[0].length;
            var styleItem = {
                'width': width + "%",
                'display': 'flex',
                'position': 'relative',
                'word-break': 'break-word'
            }
            return styleItem;
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        clearAllUpdateFields() {
            var self = this;
            self.loadedResults = null;
            self.loadedResultsFile = null;
            self.isLoadFromDataBaseRequest = false;
            self.isLoadFromDataBaseMode = false;
            self.isCheckResultsMatch = false;
            self.isCalculationsResult = false;
            self.isCalculationsSuccess = false
            self.calculationsError = null;
            self.isLoadFromFileRequest = false;
            self.isLoadFromFileMode = false;
            self.isFileLoaded = false;
            self.currentRaceId = null;
            self.isLoadingData = false;
            self.isUpdateResultsRequest = false;
            self.isUpdateResultsMode = false;
            self.isDeleteResultsLoaded = false;
            self.isDeleteProcessed = false;
            self.isDeleteSuccess = false;
            self.deleteError = null;
            self.isUpdateProcessed = false;
            self.isUpdateSuccess = false;
            self.updateError = null;
        },
        setTabsInit() {
            var self = this;
            if (self.series && self.series.length) {
                self.selectedSerieLabel = self.series[self.selectedSerieIndex > -1 ? self.selectedSerieIndex : 0].shortLabel;
                self.selectedSerie = self.series[self.selectedSerieIndex > -1 ? self.selectedSerieIndex : 0].enumValue;
            }
            if (self.years && self.years.length) {
                self.selectedYear = self.years[self.selectedYearIndex > -1 ? self.selectedYearIndex : 0];
                self.selectedYearLabel = self.years[self.selectedYearIndex > -1 ? self.selectedYearIndex : 0] + '';
            }
            self.updateRaces();
        },
        init() {
            var self = this;
            self.isProcessing = true;
            self.races = [self.noRacesEntry];
            self.years = [];
            self.series = [];

            self.fileColumnIndexes = [];
            for (var index = 0; index < self.fileColumnLength; index++)
                self.fileColumnIndexes.push(index);

            svc.getInitSeriesSettings().then(response => {
                self.isProcessing = false;
                if (response && response.body) {
                    self.series = response.body.series;
                    self.years = response.body.years
                    self.yearCalculationsFrom = response.body.yearCalculationsFrom;
                    self.setTabsInit();
                }
                else {
                    self.errorMessage = "Something went wrong, please contact with dev team!";
                }
            }, () => {
                    self.isProcessing = false;
                    self.errorMessage = "Something went wrong, please contact with dev team!";
                });

            EventBus.$off('admin-ranking-filter-updated');
            EventBus.$on('admin-ranking-filter-updated', updateModel => self.searchForRaces(true, updateModel));

            EventBus.$off('admin-ranking-change-page');
            EventBus.$on('admin-ranking-change-page', (newPage, perPage) => { self.perPage = perPage; self.changePage(newPage, perPage); });
        },
        handleTabChangeSerie(tabIndex) {
            if (this.isProcessing) {
                return;
            }
            this.selectedSerie = this.series[tabIndex].enumValue;
            this.updateRaces();

            if (self.selectedSerieIndex != tabIndex) {
                EventBus.$emit('ranking-layout-set-init-serie-index', tabIndex);
            }
            this.clearAllUpdateFields();
        },
        handleTabChangeYear(tabIndex) {
            this.selectedYear = this.years[tabIndex];
            this.updateRaces();

            if (self.selectedYearIndex != tabIndex) {
                EventBus.$emit('ranking-layout-set-init-year-index', tabIndex);
            }
            this.clearAllUpdateFields();
        },
      
        changePage(newPage, perPage) {
            var from = newPage ? (newPage - 1) * perPage : (this.page - 1) * perPage;
            if (from >= this.racesFiltered.length) {
                if (this.racesFiltered.length - perPage > 0) {
                    from = this.racesFiltered.length - perPage;
                }
                else {
                    from = 0;
                    this.page = 1;
                }
            }

            if (newPage) {
                this.races = [...this.racesFiltered].splice(from, perPage);
            }
            else {
                this.page = 1;
                this.races = [...this.racesFiltered].splice(from, perPage);
            }
        },
        searchForRaces(savePage, updateModel) {
            if (!savePage) {
                this.page = 1;
            }
            if (!updateModel) {
                this.racesFiltered = [...this.racesInput];
                this.races = [...this.racesFiltered].splice(0, this.perPage);
                return;
            }

            if (updateModel.startDateRange && updateModel.startDateRange.length > 1) {
                updateModel.startDateRange[0].setHours(1, 1, 1);
                updateModel.startDateRange[1].setHours(23, 59, 59);
            }

            var lowerfilterInput = updateModel.filterInput && updateModel.filterInput.length ? updateModel.filterInput.toLocaleLowerCase() : null;
            this.racesFiltered = [...this.racesInput
                .filter(race => {
                    return (!lowerfilterInput || race.raceName.toLocaleLowerCase().indexOf(lowerfilterInput) > -1 || race.id == lowerfilterInput) &&
                        (updateModel.selectedDistance == "All" || updateModel.selectedDistance == race.distance) &&
                        (updateModel.selectedTypeByEvent == "All" || updateModel.selectedTypeByEvent == race.typeByEvent) &&
                        (updateModel.selectedOrganizationName == "All" || updateModel.selectedOrganizationName == race.organizationName || updateModel.selectedOrganizationName == race.clubName) &&
                        (!updateModel.startDateRange || updateModel.startDateRange.length != 2 || (updateModel.startDateRange[0] <= race.startTime && updateModel.startDateRange[1] >= race.startTime));
                })];
            this.races = [...this.racesFiltered].splice(0, updateModel.perPage);
        },
        clearRaces() {
            var self = this;
            self.racesAll = [];
            self.racesFiltered = [];
            self.races = [];
            self.errorMessage = null;
        },
        prepareRacesFromResponse(response) {
            var self = this;
            if (response && response.body && response.body.isSuccess) {
                if (response.body.data) {
                    self.racesInput = response.body.data;
                }
                else {
                    self.racesInput = [self.noRacesEntry];
                }

                self.organizations = [...new Set(self.racesInput.map(x => {
                    x.startTime = new Date(x.startTime);
                    return x.organizationName ? x.organizationName : x.clubName;
                }).filter(x => x))];
                self.organizations.unshift("All");
                self.distances = [...new Set(self.racesInput.map(x => { return x.distance }))];
                self.distances.unshift("All");
                EventBus.$emit('filter-bar-update');
            }
            else {
                if (response && response.body && response.body.messsage) {
                    self.errorMessage = response.body.messsage;
                }
                else {
                    self.errorMessage = "Error while retrieving data."
                }
            }
        },
        updateRaces() {
            var self = this;
            self.clearRaces()
            if (self.selectedYear && self.selectedSerie) {
                self.isProcessing = true;
                svc.getRacesByYearAndSerieType(self.selectedSerie, self.selectedYear)
                    .then(response => {
                        self.prepareRacesFromResponse(response);
                        self.isProcessing = false;
                    },
                        () => {
                            self.errorMessage = "Error while retrieving data."
                            self.isProcessing = false;
                        });
            }

            return self.races.length;
        },

        switchPreview() {
            this.isPreviewMode = !this.isPreviewMode;

            setTimeout(() => {
                var item = document.getElementById('el-collapse-head-' + this.currentRaceId);
                if (item && item.offsetTop) {
                    window.scrollTo({ top: item.offsetTop, behavior: 'smooth' });
                }
            }, 10)
        },
        runCalculationsForFile(isPreview) {
            var self = this;
            self.isLoadingData = true;
            self.errorMessage = null;
            svc.postUploadRaceResults({ allData: self.loadedResultsFile }, self.currentRaceId, isPreview)
                .then(response => {
                    self.isLoadingData = false;
                    if (!isPreview) {
                        self.isCalculationsResult = true;
                    }
                    
                    self.isCalculationsSuccess = response && response.body && response.body.isSuccess && response.body.outputData.isSuccess
                    if (self.isCalculationsSuccess) {
                        self.loadedResults = response.body.outputData.allData;
                        self.isPreviewMode = isPreview;
                        //self.updateRaces();
                    }
                    else {
                        self.calculationsError = response && response.body && response.body.message ? response.body.message : "Unknown error with calculations happened";
                    }
                },
                    () => {
                        self.isCalculationsResult = true;
                        self.isLoadingData = false;
                        self.isCalculationsSuccess = false;
                        self.calculationsError = "Unknown error while trying to send request"
                    })
        },
        
        requestCalculationsModeForDatabase(raceId) {
            this.clearAllUpdateFields();
            this.currentRaceId = raceId;
            this.isLoadFromDataBaseRequest = true;
            this.errorMessage = null;
        },
        loadResultsFromDataBase(previewFirst) {
            var self = this;
            self.isLoadFromDataBaseMode = true;
            self.isLoadingData = true;
            self.errorMessage = null;
            self.oldDBError = null;

            svc.getOldRankingRaceResults(self.currentRaceId, (!previewFirst).toString())
                .then(response => {
                    self.isCalculationsResult = !previewFirst;
                    self.isLoadingData = false;

                    if (!response.body) {
                        self.$showError(3000);
                        return;
                    }

                    self.isCheckResultsMatch = response.body.isSuccess
                        && response.body.outputData
                        && response.body.outputData.isSuccess
                        && response.body.outputData.allData
                        && true //keep it

                    if (!self.isCheckResultsMatch) {

                        if (response.body.message) {
                            self.oldDBError = response.body.message;
                        }
                        else if (response.body.outputData && response.body.outputData.message) {
                            self.oldDBError = response.body.message;
                        }
                    }
                    else {
                        self.loadedResults = response.body.outputData.allData;
                        self.isCalculationsSuccess = self.isCalculationsResult;
                        if (self.isCalculationsSuccess) {
                            self.updateRaces();
                        }
                    }
                }, () => {
                    self.isLoadingData = false;
                    self.$showError(3000);
                });
        },
        loadResultsFromFile(previewFirst) {
            this.isPreviewFirst = previewFirst;
            this.$refs.uploader.value = null
            this.$refs.uploader.click();
        },
        loadResultsFromFileConfirmed() {
            this.isLoadFromFileMode = true;
            this.isFileLoaded = true;
            this.errorMessage = null;
            this.runCalculationsForFile(this.isPreviewFirst);
        },
        readFile() {
            var self = this;
            self.isLoadingData = true;
            self.errorMessage = null;
            var file = self.$refs.uploader.files[0];

            //if (!file || !file.type || self.fileAcceptTypes.indexOf(file.type) === -1) 
            //{
            //    self.$showError("File or it type is incorrect. Please check it, re-save with correct format - csv or xlsx.")
            //    return;
            //}

            var ext = "NONE";
            if (file && file.name) {
                var array = file.name.split(".");
                if (array && array.length) {
                    ext = array[array.length - 1];
                }
            }

            if (self.fileAcceptExtentions.indexOf(ext) === -1)
            {
                self.$showError("File or it type is incorrect. Please check it, re-save with correct format - csv or xlsx.", 3000)
                self.isProcessing = false;
                self.isLoadingData = false;
                return;
            }
            var reader = new FileReader();
            reader.onload = function (e) {
                var data = e.target.result;
                var workbook = XLSX.read(data, { type: 'binary' });
                if (workbook && workbook.SheetNames && workbook.SheetNames.length) {
                    try {
                        var object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[workbook.SheetNames[0]], { header: 1 });
                        if (object && object.length && object[0].length == self.fileColumnLength) {
                            self.loadedResultsFile = self.orderRaceResults(object);
                            self.loadResultsFromFileConfirmed();
                        }
                        else {
                            self.$showError("File contains incorrect markup or wrong number of columns");
                            self.isProcessing = false;
                            self.isLoadingData = false;
                        }
                    }
                    catch (e) {
                        self.$showError("Error while reading file: " + e);
                        self.isProcessing = false;
                        self.isLoadingData = false;
                    }
                }
            };

            reader.onerror = ex => {
                self.isLoadingData = false;
                self.$showError(ex)
            };
            reader.readAsBinaryString(file);
        },
        orderRaceResults(array, column) {
            if (!column) {
                column = 20;//placing
            }

            array = [...array]
            var header = array[0];
            array = array.splice(1, array.length - 1);
            array = array.sort((a, b) => {
                if (a[column] == b[column]) return 0;
                if (!(Number(a[column]) > 0)) return 1;
                if (!(Number(b[column]) > 0)) return -1;
                return a[column] < b[column] ? -1 : 1;
            });

            return [header].concat(array);
        },
        requestCalculationsModeForFile(raceId) {
            this.clearAllUpdateFields();
            this.currentRaceId = raceId;
            this.isLoadFromFileRequest = true;
        },
        requestUpdateMode(raceId) {
            this.clearAllUpdateFields();
            this.currentRaceId = raceId;
            this.isUpdateResultsRequest = true;
        },
        checkResultsExists() {
            var self = this;
            self.isLoadingData = true;
            self.isUpdateResultsMode = true;
            self.errorMessage = null;
            svc.getRaceResults(self.currentRaceId)
                .then(response => {
                    self.isLoadingData = false;
                    if (!response || !response.body) {
                        self.$showError();
                        return;
                    }
                    if (response.body.isSuccess && response.body.allData) {
                        self.loadedResults = response.body.allData;
                        self.isPreviewMode = true;
                    }
                    if (response.body && response.body.message) {
                        self.$showError(response.body.message);
                    }
                }, () => {
                    self.$showError("Unknown error occured. Please verify your internet connection and try again.")
                    self.isLoadingData = false;
                });
        },
        deleteRaceResults() {
            var self = this;
            self.isLoadingData = true;
            self.isUpdateResultsMode = true;
            self.errorMessage = null;
            svc.deleteRaceResults(this.currentRaceId)
                .then(response => {
                    self.isLoadingData = false;
                    self.isDeleteProcessed = true;
                    if (!response || !response.body) {
                        self.$showError();
                        return;
                    }

                    self.isDeleteSuccess = response.body.isSuccess;
                    if (self.isDeleteSuccess) {
                        self.updateRaces();
                    }

                    if (!self.isDeleteSuccess && response.body.message) {
                        self.$showError(response.body.message)
                    }
                }, () => {
                    self.isLoadingData = false;
                    self.isDeleteProcessed = true;
                    self.deleteError = 'Something went wrong. Check the connetion.'
                    self.$showError();
                });
        },
        reCalculate() {
            var self = this;
            self.isLoadingData = true;
            self.isUpdateResultsMode = true;
            self.errorMessage = null;
            svc.getReCalculateAndSaveRaceResults(self.currentRaceId)
                .then(response => {
                    self.isLoadingData = false;
                    self.isUpdateProcessed = true;
                    if (!response || !response.body) {
                        self.$showError();
                        return;
                    }

                    self.isUpdateSuccess = response.body.isSuccess;

                    if (response.body.outputData && response.body.outputData.allData && response.body.outputData.allData.length) {
                        self.loadedResults = response.body.outputData.allData;
                    }

                    if (!self.isUpdateSuccess && response.body.message) {
                        self.updateError = response.body.message;
                        self.$showError(response.body.message)
                    }
                }, () => {
                    self.isLoadingData = false;
                    self.isUpdateProcessed = true;
                    self.updateError = 'Something went wrong. Check the connetion.'
                    self.$showError();
                });
        },
        download() {
            EventBus.$emit('race-result-download');
        },

        clearOldRankingCalculationFields() {
            this.isDeleteRacesResultsFromSerieRequest = false;
            this.isDeleteRacesFromSerieRequest = false;

            this.isLoadFromOldRankingRequest = false;
            this.isLoadClubsRankingFromOldRankingRequest = false;

            this.isDeleteRacesResultsFromSerieSuccess = false;
            this.isDeleteRacesFromSerieSuccess = false;

            this.isLoadFromOldRankingSuccess = false;
            this.isLoadClubsRankingFromOldRankingSuccess = false;
        },

        deleteRacesResultsFromSerieSwitch() {
            var newValue = !this.isDeleteRacesResultsFromSerieRequest;
            this.clearAllUpdateFields();
            this.isDeleteRacesResultsFromSerieRequest = newValue;
        },
        deleteRacesResultsFromSerieConfirmed() {
            var self = this;
            self.isProcessing = true;
            svc.deleteClearRankingResults(self.selectedYear, self.selectedSerie)
                .then(response => {
                    self.isDeleteRacesResultsFromSerieSuccess = self.prepareSimpleResponse(response);
                    if (self.isDeleteRacesResultsFromSerieSuccess) {
                        self.clearOldRankingCalculationFields();
                    }
                },
                    err => { self.prepareSimpleError(err); })
        },

        deleteRacesFromSerieSwicth() {
            var newValue = !this.isDeleteRacesFromSerieRequest;
            this.clearAllUpdateFields();
            this.isDeleteRacesFromSerieRequest = newValue;
        },
        deleteRacesFromSerieConfirmed() {
            var self = this;
            self.isProcessing = true;
            svc.deleteClearRacesFromSerie(self.selectedYear, self.selectedSerie)
                .then(response => {
                    self.isDeleteRacesFromSerieSuccess = self.prepareSimpleResponse(response);
                    if (self.isDeleteRacesFromSerieSuccess) {
                        self.clearOldRankingCalculationFields();
                    }
                },
                    err => { self.prepareSimpleError(err); })
        },

        loadFromOldRankingsSwitch() {
            var newValue = !this.isLoadFromOldRankingRequest;
            this.clearAllUpdateFields();
            this.isLoadFromOldRankingRequest = newValue;
        },
        loadFromOldRankingsConfirmed() {
            var self = this;
            self.isProcessing = true;
            svc.postCopyResultsForYearAndSerie(self.selectedYear, self.selectedSerie)
                .then(response => {
                    self.isLoadFromOldRankingSuccess = self.prepareSimpleResponse(response);
                    if (self.isLoadFromOldRankingSuccess) {
                        self.clearOldRankingCalculationFields();
                    }
                },
                    err => { self.prepareSimpleError(err); })
        },

        loadClubsRankingFromOldRankingsSwitch() {
            var newValue = !this.isLoadClubsRankingFromOldRankingRequest;
            this.clearAllUpdateFields();
            this.isLoadClubsRankingFromOldRankingRequest = newValue;
        },
        loadClubsRankingFromOldRankingsConfirmed() {
            var self = this;
            self.isProcessing = true;
            svc.postCopyResultsForClubSeries(self.selectedYear)
                .then(response => {
                    self.isLoadClubsRankingFromOldRankingSuccess = self.prepareSimpleResponse(response);
                    if (self.isLoadClubsRankingFromOldRankingSuccess) {
                        self.clearOldRankingCalculationFields();
                    }
                },
                    err => { self.prepareSimpleError(err); })
        },

        prepareSimpleError(response) {
            this.isProcessing = false;
            if (response && response.body) {
                if (response.body.message) {
                    this.$showError(response.body.message);
                }
                else if (response.body.errorMessage) {
                    this.$showError(response.body.errorMessage);
                }
                else {
                    this.$showError();
                }
            }
            else {
                this.$showError()
            };
        },
        prepareSimpleResponse(response) {
            this.isProcessing = false;
            var isSuccess = response && response.body && response.body.isSuccess;
            if (isSuccess) {
                this.$showSuccess();
                this.updateRaces();
            }
            else {
                this.prepareSimpleError(response);  
            }
            
            return isSuccess;
        }
    },
    mounted() {
        this.init();
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/ranking/upload-results/upload-results.js